var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"folders-provider",class:{
    'is-sidebar-minimized': _vm.isSidebarMinimized,
    'single-essay-page': _vm.isSingleEssayPage,
  }},[_vm._t("default",null,{"loadingFolders":_vm.loadingFolders})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }